import { StatusColumnFormat } from './ColumnsFormatters/StatusColumnFormat';

export const recordTypeTabs = [
	{ value: 1, label: 'Bitácora por Usuario' },
	{ value: 2, label: 'Bitácora por Usuario Afectado' },
];

export const access_columns = [
	{
		dataField: 'FullLinkName',
		text: 'Nombre',
		headerAlign: 'left',
		style: { maxWidth: '120px' },
	},
	{
		dataField: 'usuario',
		text: 'Usuario',
		headerAlign: 'left',
	},
	{
		dataField: 'tipoPerfil',
		text: 'Perfil',
		headerAlign: 'left',
		style: { maxWidth: '120px' },
	},
	{
		dataField: 'accion',
		text: 'Acción',
		headerAlign: 'left',
	},
	{
		dataField: 'email',
		text: 'Email',
		headerAlign: 'left',
	},
	{
		dataField: 'estatus',
		text: 'Estatus',
		headerAlign: 'left',
		formatter: StatusColumnFormat,
		style: { maxWidth: '40px' },
	},
	{
		dataField: 'fechaHoraAcceso',
		text: 'Fecha',
		headerAlign: 'left',
		style: { maxWidth: '99px' },
	},
];

export const logSegurityColumns = [
	{
		dataField: 'usuarioAfectado',
		text: 'Usuario Afectado',
		headerAlign: 'left',
	},
	{
		dataField: 'nombreusurioAfectado',
		text: 'Nombre del Afectado',
		headerAlign: 'left',
	},
	{
		dataField: 'usuario',
		text: 'Usuario Quien Realizó la Acción',
		headerAlign: 'left',
	},
	{
		dataField: 'FullLinkName',
		text: 'Nombre Quien Realizó la Acción',
		headerAlign: 'left',
	},
	{
		dataField: 'accion',
		text: 'Acción que se le Realizó al Afectado',
		headerAlign: 'left',
	},
	{
		dataField: 'email',
		text: 'Email Quien Realizó la Acción',
		headerAlign: 'left',
	},
	{
		dataField: 'estatus',
		text: 'Estatus Quien Realizó la Acción',
		headerAlign: 'left',
		formatter: StatusColumnFormat,
	},
	{
		dataField: 'fechaHoraAcceso',
		text: 'Fecha y hora',
		headerAlign: 'left',
		style: { maxWidth: '99px' },
	},
];

export const defaultFilter = {
	user: '',
	status: 'A',
	start_date: null,
	end_date: null,
	nick: '',
};

export const defaultFilter2 = {
	user2: '',
	status2: 'A',
	start_date2: null,
	end_date2: null,
	nick2: '',
};

export const filterForm1 = (onConfirmFilter, onClear, users = []) => [
	{
		label: 'Nombre de Usuario',
		placeholder: 'Nombre de Usuario',
		name: 'user',
		type: 'search',
		options: [...users],
		column: 4,
	},
	{
		label: 'Clave de usuario',
		placeholder: 'Buscar por IN/IS',
		name: 'nick',
		type: 'text',
		column: 2,
	},
	{
		label: '*Estatus',
		name: 'status',
		type: 'chip-dropdown',
		options: [
			{ value: 'A', text: 'Activo', color: 'primary' },
			{ value: 'I', text: 'Inactivo', color: 'black' },
			{ value: 'B', text: 'Baja', color: 'danger' },
		],
		column: 2,
	},
	{
		label: 'Fecha de Inicio',
		name: 'start_date',
		type: 'date',
		column: 2,
	},
	{
		label: 'Fecha de Fin',
		name: 'end_date',
		type: 'date',
		column: 2,
	},
	{
		type: 'inner-column',
		column: 10,
	},
	{
		label: 'Limpiar',
		name: 'Limpiar',
		color: 'light-primary',
		type: 'button',
		onClick: onClear,
		column: 1,
		style: { width: '100%' },
	},
	{
		label: 'Buscar',
		name: 'Buscar',
		color: 'info',
		type: 'button',
		column: 1,
		onClick: onConfirmFilter,
		style: { width: '100%' },
	},
];

export const filterForm2 = (onConfirmFilter, onClear, users = []) => [
	{
		label: 'Nombre de Usuario',
		placeholder: 'Nombre de Usuario',
		name: 'user2',
		type: 'search',
		options: [...users],
		column: 4,
	},
	{
		label: 'Buscar por IN/IS',
		placeholder: 'Buscar por IN/IS',
		name: 'nick2',
		type: 'text',
		column: 2,
	},
	{
		label: '*Estatus',
		name: 'status2',
		type: 'chip-dropdown',
		options: [
			{ value: 'A', text: 'Activo', color: 'primary' },
			{ value: 'I', text: 'Inactivo', color: 'black' },
			{ value: 'B', text: 'Baja', color: 'danger' },
		],
		column: 2,
	},
	{
		label: 'Fecha de Inicio',
		name: 'start_date2',
		type: 'date',
		column: 2,
	},
	{
		label: 'Fecha de Fin',
		name: 'end_date2',
		type: 'date',
		column: 2,
	},
	{
		type: 'inner-column',
		column: 10,
	},
	{
		label: 'Limpiar',
		name: 'Limpiar2',
		color: 'light-primary',
		type: 'button',
		onClick: onClear,
		column: 1,
		style: { width: '100%' },
	},
	{
		label: 'Buscar',
		name: 'Buscar2',
		color: 'info',
		type: 'button',
		column: 1,
		onClick: onConfirmFilter,
		style: { width: '100%' },
	},
];
